// extracted by mini-css-extract-plugin
export default {"tag":"MGTag_tag__+vdB+","label":"MGTag_label__e0y2p","close":"MGTag_close__-vR-E"};